module.exports = __webpack_public_path__ + "img/buttons.27f67846.webp";